//3rd Party Components
import React, { Fragment } from 'react';
import { useSelector } from "react-redux";
import MetaTags from 'react-meta-tags';
import { AUformGroup } from '@gov.au/form';
import AUdirectionLink from '@gov.au/direction-links';

//Actions
import { getUrlSelector } from 'PortalStore/Selectors/EnvDataSelectors';
import { getPortalUrl } from 'components/Portal/Utilities';

export const DVSServiceUnavailable = () => {
    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let urlHome = useSelector(state => getUrlSelector(state, "Portal - Home URL"));

    const loc = getPortalUrl("/", standalone, urlHome); 

    return (
        <Fragment>
            <MetaTags>
                <title>Error</title>
            </MetaTags>

            <div>
                <h2 style={{ marginTop: '20px' }} >Something went wrong</h2>
                <p>
                    There is a problem with the verification service.
                </p>
                <p>
                    Please try again later, or you can use <a href='https://www.digitalidentity.gov.au/create-or-manage-your-digital-id' target="_blank" rel="noopener noreferrer">Digital Identity</a> to create your myCASA account and verify your identity.<br />
                </p>

            </div>

            <div>
                <AUformGroup>
                    <AUdirectionLink link= {loc} text='Return to myCASA' direction='left' style={{ marginTop: '20px' }} />
                </AUformGroup>
            </div>

        </Fragment>
    );
    
}

